import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { genericApi } from '../../../common/apiconfig';
import CircularProgress from '@material-ui/core/CircularProgress';
import StickyNotes from '../../../globalcomponents/stickyNotes/stickyNotes';
const Notes = (propsobj) => {
  const [showForm, setshowForm] = useState(false);
  let [progress, setProgress] = useState(false);
  const [error, setError] = useState(null);
  const [notesData, setNotesData] = useState(null);;
  const addNote = () => {
    propsobj.history.push('/account/studyDetails/site/siteDetails/notes/addNotes');
    setshowForm(!showForm);
  }


  const fetchNotes = async () => {
    setProgress(true)
    let requestBody = JSON.stringify({
      query: `
        query {
            getStudySiteNote(studyId: "${propsobj.formValues.autostudy.studyId}", siteId: "${propsobj.formValues.autosite.sponsorAccountId}", noteType: "*", noteId: "*") {
                sn {
                    noteId
                    studyId
                    siteId
                    notes
                    title
                    noteType
                    createdBy
                    createdTs
                    modifiedBy
                    modifiedTs
                }
                     link {
      ID
      buArea
      buid
      type
      status
      detail1
      detail2
      detail3
      detail4
      addedById
      addedByName
      addedTs
    }
    document {
      ID
      buArea
      buid
      type
      status
      detail1
      detail2
      detail3
      detail4
      addedById
      addedByName
      addedTs
    }
    video {
      ID
      buArea
      buid
      type
      status
      detail1
      detail2
      detail3
      detail4
      addedById
      addedByName
      addedTs
    }
            }
        }`
    });

    try {
      let res = await genericApi("getStudySiteNote", requestBody);
      console.log("API Response:", res);
      if (res?.data?.getStudySiteNote) {
        setNotesData(res.data.getStudySiteNote);
        setProgress(false)
      } else {
        setError("Error fetching notes data.");
      }
    } catch (err) {
      console.error("Error fetching study notes:", err);
      setError("Failed to fetch data.");
    }
  };

 

  const handleNoteDeleted = () => {
    fetchNotes();
  };

//   if(localStorage.getItem('whichApp')==="Site"){
//     propsobj.history.push('/site/users/edit');
//   }
  useEffect(() => {
    fetchNotes();
  }, [propsobj.formValues.autostudy.studyId]);
  const accountType = localStorage.getItem('whichApp');

  return (
    <>
     {progress && <div className="fullScreen">
            <CircularProgress
              disableShrink
              className="progressCircle"
              value={90}
              size={100}
              thickness={1.5}
            />
            {/* <Loader/> */}
          </div>}
      <div className='d-flex flex-row'>
        <div className="d-flex flex-column">
        <div class="secondary-header mr-auto">Notes</div>
        </div>
          <div className='m-5' style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)', // 4 equal columns 
          gap: '10px'
        }}>
            
          <StickyNotes data={notesData} onDelete={handleNoteDeleted} accountType={accountType}/>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    state
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateFormField: (obj) => {
      return dispatch(
        {
          type: 'UpdateFormField',
          value: obj.value,
          name: obj.name
        }
      )
    },
    clearForm: () => {
      return dispatch(
        {
          type: 'ClearForm',
        }
      )
    },
    updateErrorObj: (obj) => {
      return dispatch(
        {
          type: 'updateErrorObj',
          flag: obj.flag,
          name: obj.name,
          text: obj.text
        }
      )
    },
    updateEntireErrorObj: (errobj, errtextobj) => {
      return dispatch(
        {
          type: 'updateEntireErrorObj',
          errobj: errobj,
          errtextobj: errtextobj,
        }
      )
    },
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Notes));